export enum AppLookupItemKeys {
  WDCostCenter = 'Work Day - Cost Center',
  WDGrantWorkTag = 'Work Day - Grant Work Tag',
}
